// extracted by mini-css-extract-plugin
module.exports = {"image":"ContainerWithPoint_image__27BoY","point":"ContainerWithPoint_point__L7Gi_","popup":"ContainerWithPoint_popup__Pqgoe","text":"ContainerWithPoint_text__1kFzA"};